// extracted by mini-css-extract-plugin
export default {"wrapper":"ParticleIcon_wrapper_a473c","content":"ParticleIcon_content_c2655","icon":"ParticleIcon_icon_c315b","compact":"ParticleIcon_compact_f6c83"};